module.exports = __webpack_public_path__ + "img/banner-3.55f645f1.png";